import { AutoMap } from "@automapper/classes";


export class UserDTO {
    @AutoMap()
    email!: string;
    @AutoMap()
    password!: string;
    @AutoMap()
    phone!: string;
    @AutoMap()
    firstName!: string;
    @AutoMap()
    lastName!: string;

}
